import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface NotificationState {
  id: string;
  message: string;
  createdDate: string;
  status: string;
  props: {
    [key: string]: any;
  };
}

const initialState: NotificationState = {
  id: '',
  message: '',
  createdDate: '',
  status: '',
  props: { isModalVisible: false, refresh: false, searchTerm: '', skip: 0, take: 10, totalItems: 0 },
};

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    setNotification: (state, action: PayloadAction<Partial<NotificationState>>) => {
      return { ...state, ...action.payload };
    },

    resetProps: (_state, action: PayloadAction<Partial<NotificationState['props']> | undefined>) => {
      return {
        ...initialState,
        props: { ...initialState.props, ...action.payload },
      };
    },

    updateField: (state: NotificationState, action: PayloadAction<{ field: any; value: any }>) => {
      const { field, value } = action.payload;
      (state as any)[field] = value;
    },

    updateProps: (state, action: PayloadAction<{ field: string; value: any }>) => {
      const { field, value } = action.payload;
      state.props = {
        ...state.props,
        [field]: value,
      };
    },
  },
});

export const { setNotification, resetProps, updateField, updateProps } = notificationSlice.actions;

export default notificationSlice.reducer;
